export default __webpack_public_path__ + "locales/si/Errors.json?hash=79be7b2d0c90358f6884fc7d48cbd591";